import useEST from 'hooks/API/GET/useEST';
import useManageEST from 'hooks/API/useManageEST';
import useToaster from 'hooks/useToaster';
import { useParams, useHistory } from 'react-router-dom';
import ESTHandleSection from './ESTHandleSection';
import * as AppPics from 'assets/images';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';

function ManageEST() {
  const { isLoading, mutate, isError } = useManageEST();
  const { estID } = useParams();
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  const { data } = useEST({
    enabled: !!estID,
    estID,
  });

  function handleClass(classFormData = {}) {
    if (isLoading) return;

    if (data?.data?._id) {
      classFormData.id = data?.data?._id;
    }

    mutate(classFormData);
  }

  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back" onClick={handleGoBack}>
              <img src={AppPics.BackSvg} alt="Back" />
            </button>
          </li>
        </ul>

        <div className="tab__content ___adjust___tab___padding">
          <div className="tab__content-actHead">
            <AppBreadcrumbs
              links={[
                { label: 'Dashboard', to: '/dashboard' },
                { label: 'Curriculum', to: '/curriculum' },
                { label: 'Regions', to: '/manage/est' },
              ]}
              current={estID ? 'Update Region' : 'Add Region'}
            />
          </div>

          <div className="tab__content-actBody">
            <div className="px-5 py-2">
              <ESTHandleSection
                handleClass={handleClass}
                preloadedData={data?.data ?? {}}
                editMode={!!estID}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageEST;
